'use client'

import { type FC } from 'react'

import { cx } from 'cva'
import { motion } from 'framer-motion'
import type { IconType } from '../../frontend-types'
import type { IMarkerData } from '../molecules/VenuesMap/types'
import { FontAwesomeIcon } from './FontAwesomeIcon'
import MapPopover from './MapPopover'

export type MapMarkerProps = {
	data: IMarkerData
	onSelectVenue: (venueId: string | null) => void
	selected: boolean
}

const MapMarker: FC<MapMarkerProps> = ({ data, onSelectVenue, selected }) => {
	const { id, name, iconPrefix, iconName } = data

	const icon: IconType = iconPrefix && iconName ? [iconPrefix, iconName] : ['far', 'court-sport']

	return (
		<motion.div className="relative">
			<motion.button
				id={`marker-${id}`}
				aria-label={name}
				aria-expanded={selected}
				whileHover={!selected ? { scale: 1.1 } : {}}
				className="block relative cursor-pointer"
				onClick={() => onSelectVenue(id)}
			>
				<div
					className={cx(
						'flex items-center justify-center rounded-md border-(length:--stroke-md) w-12 h-12',
						!selected
							? 'bg-white border-blue text-blue hover:bg-blue-tint-10 hover:border-blue-shade-40 hover:text-blue-shade-40'
							: 'bg-blue-tint-20 border-blue-shade-70 text-blue-shade-70',
					)}
				>
					<FontAwesomeIcon icon={icon} size="xl" />
				</div>
			</motion.button>
			<MapPopover id={id} data={data} selected={selected} onSelectVenue={onSelectVenue} />
		</motion.div>
	)
}

export default MapMarker
